import request from '@/utils/request'

// #region --------------------------人员定位------------------------------

/**
 * 查询人员定位列表
 * @param {object} parameter
 */
export function getPersonnelPositionList (parameter) {
  return request({
    url: '/machineryMgt/iot/PersonnelPosition/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 请选择隧道
 * @param {object} parameter
 */
export function getChooseTunnel (parameter) {
  return request({
    url: '/machineryMgt/iot/PersonnelPosition/chooseTunnel',
    method: 'get',
    params: parameter
  })
}

/**
 * 人员实时统计
 * @param {object} parameter
 */
export function getPersonnelRealTimeStatistics (parameter) {
  return request({
    url: '/machineryMgt/iot/PersonnelPosition/personnelRealTimeStatistics',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询人员定位历史定位列表
 * @param {object} parameter
 */
export function getPersonnelPositionHistoryList (parameter) {
  return request({
    url: '/machineryMgt/iot/PersonnelPositionHistory/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询人员定位预警记录列表
 * @param {object} parameter
 */
export function getPersonnelPositionWarnList (parameter) {
  return request({
    url: '/machineryMgt/iot/PersonnelPositionWarn/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询人员定位预警记录详情
 * @param {object} parameter
 */
export function getPersonnelPositionWarn (parameter) {
  return request({
    url: `/machineryMgt/iot/PersonnelPositionWarn/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改人员定位预警记录
 * @param {object} parameter
 */
export function putPersonnelPositionWarn (parameter) {
  return request({
    url: `/machineryMgt/iot/PersonnelPositionWarn/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查看人员定位详情
 * @param {object} parameter
 */
export function getPersonnelPosition (parameter) {
  return request({
    url: `/machineryMgt/iot/PersonnelPosition/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 修改人员定位工种
 * @param {object} parameter
 */
export function updateWorkType (parameter) {
  return request({
    url: `/machineryMgt/iot//PersonnelPosition/updateWorkType`,
    method: 'put',
    data: parameter
  })
}

/**
 * 获取人员定位工种列表
 * @param {object} parameter
 */
export function listWorkerType (parameter) {
  return request({
    url: `/machineryMgt/iot//PersonnelPosition/listWorkerType`,
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------监测通用------------------------------

/**
 * 监测点位备选项列表
 * @param {object} parameter
 * @property {number} deviceType 预警设备类型 1-边坡监测 2-应力监测 3-沉降监测 4-缆绳吊监测 5-水土流失监测 6-气体监测
 */
export function getMonitorPointsList (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoring/getMonitorPointsList',
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------气体监测------------------------------

/**
 * 查询气体监测列表
 * @param {object} parameter
 */
export function getGasMonitoringList (parameter) {
  return request({
    url: '/machineryMgt/iot/GasMonitoring/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 气体监测近15日监测
 * @param {object} parameter
 */
export function gasMonitoringPast15Days (parameter) {
  return request({
    url: '/machineryMgt/iot/GasMonitoring/gasMonitoringPast15Days',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改气体监测阈值表
 * @param {object} parameter
 */
export function putGasMonitoringThreshold (parameter) {
  return request({
    url: '/machineryMgt/iot/GasMonitoringThreshold/',
    method: 'put',
    data: parameter
  })
}

/**
 * 查询气体监测阈值表列表
 * @param {object} parameter
 */
export function getGasMonitoringThresholdList (parameter) {
  return request({
    url: '/machineryMgt/iot/GasMonitoringThreshold/list',
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------安全步距监测------------------------------

/**
 * 查询安全布距监测列表
 * @param {object} parameter
 */
export function getSafetyStepMonitoringList (parameter) {
  return request({
    url: '/machineryMgt/iot/SafetyStepMonitoring/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 请选择隧道
 * @param {object} parameter
 */
export function getChooseTunnelSafetyStep (parameter) {
  return request({
    url: '/machineryMgt/iot/SafetyStepMonitoring/chooseTunnel',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询安全布距监测历史定位列表
 * @param {object} parameter
 */
export function getSafetyStepMonitorHistoryList (parameter) {
  return request({
    url: '/machineryMgt/iot/SafetyStepMonitorHistory/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询安全布距监测预警记录列表
 * @param {object} parameter
 */
export function getSafetyStepMonitorWarnList (parameter) {
  return request({
    url: '/machineryMgt/iot/SafetyStepMonitorWarn/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询安全布距监测预警记录详情
 * @param {object} parameter
 */
export function getSafetyStepMonitorWarn (parameter) {
  return request({
    url: `/machineryMgt/iot/SafetyStepMonitorWarn/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改安全布距监测预警记录
 * @param {object} parameter
 */
export function putSafetyStepMonitorWarn (parameter) {
  return request({
    url: `/machineryMgt/iot/SafetyStepMonitorWarn/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 保存安全步距监测
 * @param {object} parameter
*/
export function saveSafetyStepMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/SafetyStepMonitoring/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改安全步距监测历史定位
 * @param {object} parameter
*/
export function postSafetyStepMonitorHistory (parameter) {
  return request({
    url: `/machineryMgt/iot/SafetyStepMonitorHistory/save`,
    method: 'post',
    data: parameter
  })
}

/**
 * 根据id删除气体监测
 * @param {object} parameter
*/
export function deleteGasMonitoringById (parameter) {
  return request({
    url: `/machineryMgt/iot/GasMonitoring/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 批量保存iot设备表
 * @param {object} parameter
*/
export function saveIotDeviceBatch (parameter) {
  return request({
    url: `/machineryMgt/iot/IotDevice/saveIotDeviceBatch`,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询iot设备表列表
 * @param {object} parameter
 */
export function getIotDeviceList (parameter) {
  return request({
    url: '/machineryMgt/iot/IotDevice/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询气体监测详情
 * @param {object} parameter
 */
export function getGasMonitoringDetails (parameter) {
  return request({
    url: `/machineryMgt/iot/GasMonitoring/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 保存气体监测
 * @param {object} parameter
*/
export function saveIotGasMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/GasMonitoring/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改气体监测
 * @param {object} parameter
*/
export function updateIotGasMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/GasMonitoring/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 导入
 */
export function importExcelNew (parameter) {
  return request({
    url: `/file/excel/importExcelNew`,
    timeout: 2 * 60 * 1000,
    method: 'post',
    data: parameter
  })
}

/**
 * 新增或修改人员信息
 * @param {object} parameter
 */
export function batchUpdatePersonnelPositionHistory (parameter) {
  return request({
    url: '/machineryMgt/iot/PersonnelPositionHistory/batchUpdate',
    method: 'post',
    data: parameter
  })
}

/**
 * 新增或修改人员信息
 * @param {object} parameter
 */
export function dataAllocationSaveOrUpdateUser (parameter) {
  return request({
    url: '/machineryMgt/iot/PersonnelPosition/dataAllocationSaveOrUpdateUser',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除实时定位
 * @param {object} parameter
 */
export function deletePersonnelPositionById (parameter) {
  return request({
    url: `/machineryMgt/iot/PersonnelPosition/${parameter.id}`,
    method: 'delete'
  })
}

// #endregion
